<template>
  <div
    ref="headerWrapper"
    :class="[
      'header-wrapper',
      'header-wrapper__banner',
      isMenuOpen ? 'header-modal' : 'header-not-modal',
    ]"
  >
    <div ref="headerDiv" class="header l-container">
      <div
        :class="['header-menu-open', { 'go-up': openHeaderMenu }]"
        @click="clickHeaderMenu"
      >
        <UiIcon
          v-if="openHeaderMenu"
          name="close"
          size="20"
          alt="Закрыть меню"
        />
        <UiIcon v-else name="header-burger" size="20" alt="Открыть меню" />
      </div>
      <nuxt-link class="logo" to="/" @click="globalStore.setMenuOpen(false)">
        <img
          class="img"
          src="/static/images/logo-price-ru.svg"
          alt="price.ru"
        />
      </nuxt-link>
      <div
        class="catalog-button"
        @click="
          globalStore.setMenuOpen(!isMenuOpen);
          sendYa();
        "
      >
        <UiHamburger :open="isMenuOpen" />
        <span class="label body-l-regular">Каталог</span>
      </div>

      <div ref="navDiv" class="nav-container">
        <AppMainMenu :class="{ hide: !isMenuOpen }" @search="setSearchFocus" />
      </div>

      <div
        ref="searchelement"
        :class="['search', { 'show-mobile-search': showMobileSearch }]"
      >
        <UiHeaderSearch
          :class="{ 'catalog-visible': isMenuOpen }"
          @toggle-visible-catalog="globalStore.setMenuOpen(false)"
          @show-bottom-menu="showBottomMenu"
          @on-blur="showMobileSearch = false"
        />
      </div>

      <UiBottomMenu
        :class="{
          'bm-in-header': !mediaStore.isTablet,
          'go-up': openHeaderMenu || isMenuOpen,
        }"
        @toggle-visible-catalog="
          globalStore.setMenuOpen($event);
          openHeaderMenu = false;
        "
      />

      <div class="line-second-line">
        <div class="city-wrapper" @click="selectCityModal = true">
          <div class="city">
            <span class="question-wrapper">
              <UiIcon name="geo-target" class="geo-icon" />
              <span class="name text-body-m-book">
                <span class="city-name body-m-regular">{{ city }}</span>
              </span>
              <!--noindex-->
              <client-only>
                <div v-if="showQuestion" class="question">
                  <div class="text">
                    Ваш город <b>{{ localRegion?.name }}</b
                    >?
                  </div>
                  <div class="buttons">
                    <ui-ui-button
                      size="medium"
                      type="primary"
                      @click.stop="approveCity"
                    >
                      Да, верно
                    </ui-ui-button>
                    <ui-ui-button
                      size="medium"
                      type="secondary"
                      @click.stop="cancelCity"
                    >
                      Нет, другой
                    </ui-ui-button>
                  </div>
                </div>
              </client-only>
              <!--/noindex-->
            </span>
          </div>
        </div>
        <ui-horizontal-scroll>
          <ul class="site-menu">
            <li
              v-for="(item, index) in menuItems"
              :key="`${item?.name}-${index}`"
              :class="[
                item?.name ? 'site-menu__item' : 'delimeter',
                item.class,
                'body-m-regular',
              ]"
            >
              <nuxt-link
                v-if="item?.name && item.name !== 'exclusive'"
                :to="item.href"
                :class="[{ has_icon: item.icon }, 'body-m-regular']"
                @click="sendYaClick(item.href)"
              >
                <UiIcon v-if="item.icon" :name="item.icon" />
                <span class="body-m-regular">{{ item?.name }}</span>
              </nuxt-link>
              <div
                v-else-if="item?.name && item.name === 'exclusive'"
                class="exclusive"
                :class="{ exclusive__gif: isFirstInteractive }"
                @click="showExclusive"
              />
            </li>
          </ul>
        </ui-horizontal-scroll>
      </div>

      <button class="header-search-button-mob" @click="setSearchFocus">
        <span class="header-search-button-mob-icon-wrap">
          <UiIcon name="header-search" size="20" stroke="#ffffff" />
        </span>
      </button>

      <!--      <UiBottomMenu @toggleVisibleCatalog="globalStore.setMenuOpen($event)"/>-->
    </div>
    <LazyModalsCitySelectModal
      v-if="selectCityModal"
      class="city-select-modal"
      @close="closeModal"
      @set-city="setActiveCity"
    />
    <div v-if="openHeaderMenu" :class="['shadow']" />
    <UiHeaderMenu
      v-if="openHeaderMenu"
      @hide="clickHeaderMenu"
      @toggle-visible-catalog="
        globalStore.setMenuOpen($event);
        openHeaderMenu = false;
      "
    />
    <div class="exclusive-mobile" @click="showExclusive">
      <div
        class="exclusive-mobile__banner"
        :class="{ 'exclusive-mobile__gif': isFirstInteractive }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useScrollLock } from '@vueuse/core';
import { callWithNuxt, useNuxtApp } from 'nuxt/app';
import { defaultRegion, useGlobalStore } from '~/stores/global';
import { hostData } from '~/utils/urlHelpers';
import { maxAge } from '~/common/const';
import { useMediaQueryStore } from '~/stores/mediaQuery';
import { useModalsStore } from '~/stores/modals';
import { useInteractiveStore } from '~/stores/interactive';
import type { RegionInApp } from '~/interfaces/app';

const router = useRouter();
const globalStore = useGlobalStore();
const modalsStore = useModalsStore();
const mediaStore = useMediaQueryStore();
const interactiveStore = useInteractiveStore();
const isFirstInteractive = computed(() => interactiveStore.isFirstInteractive);
const nuxtApp = useNuxtApp();
const { $ymAnyEvent } = nuxtApp;
const searchelement = ref<HTMLElement | undefined>();
const selectCityModal = ref(false);
const openHeaderMenu = ref(false);
const showMobileSearch = ref(false);
const headerDiv = ref();
const navDiv = ref();
const isMenuOpen = computed(() => globalStore.isMenuOpen);
const localRegion = ref(defaultRegion);
const city = ref(globalStore.region?.name || 'Москва');
const region = computed(() => globalStore.region);
const showQuestion = computed(
  () =>
    !globalStore.isBot &&
    globalStore.region.needQuestion &&
    globalStore.localRegion &&
    !openHeaderMenu.value &&
    !isMenuOpen.value
);
const html = ref<HTMLElement | null>(null);
const isLocked = useScrollLock(html);

const menuItems = [
  {
    name: 'exclusive',
    href: '',
    icon: '',
    class: 'allways',
  },
  {
    name: 'Промокоды',
    href: '/promokody/',
    icon: 'fire',
    class: 'allways',
  },
  {
    name: 'Скидки дня',
    href: '/promo/sale/',
    icon: 'sale',
    class: 'allways',
  },
  {
    name: 'Блог',
    href: 'https://price.ru/blog/',
    class: 'allways',
  },
  {
    name: 'Бренды',
    href: '/brands/',
    class: 'allways',
  },
  {
    name: '',
    class: 'desktop',
  },
  {
    name: 'Компьютеры',
    href: '/sistemnye-bloki/',
    class: 'desktop',
  },
  {
    name: 'Смартфоны',
    href: '/mobilnye-telefony/smartfony/',
    class: 'desktop',
  },
  {
    name: 'Холодильники',
    href: '/bytovye-holodilniki-morozilniki/',
    class: 'superdesktop',
  },
  {
    name: 'Телевизоры',
    href: '/televizory/',
    class: 'superdesktop',
  },
  {
    name: '',
    class: 'allways',
  },
  {
    name: 'Продавайте на Price',
    href: 'https://biz.price.ru/welcome/',
    class: 'allways',
  },
];

const showBottomMenu = computed(
  () => globalStore.isMenuOpen && (mediaStore.isTablet || mediaStore.isMobile)
);
const closeModal = () => {
  selectCityModal.value = false;
};
const setActiveCity = (city: RegionInApp) => {
  if ($ymAnyEvent) {
    $ymAnyEvent('reachGoal', 'click_city');
  }
  const { isSubdomain, domain, domainWithPort } = hostData(
    window.location.hostname,
    window.location.port
  );
  const cookieRegion = useCookie('region', {
    path: '/',
    domain,
    maxAge,
  });
  cookieRegion.value = JSON.stringify(city);

  if (
    city.id !== globalStore.region.id ||
    city.name !== globalStore.region.name
  ) {
    const newLocation = `//${
      city.subdomain ? city.subdomain + '.' : ''
    }${domainWithPort}${window.location.pathname + window.location.search}`;
    globalStore.setRegion(city);
    const app = useNuxtApp();
    setTimeout(() => {
      callWithNuxt(app, () =>
        navigateTo(newLocation, {
          external: true,
          redirectCode: 301,
        })
      );
    }, 500);
  } else {
    if (
      nuxtApp.vueApp.$nuxt?.$ymInit &&
      typeof nuxtApp.vueApp.$nuxt.$ymInit === 'function'
    )
      nuxtApp.vueApp.$nuxt?.$ymInit();
    globalStore.setRegion({
      needQuestion: false,
      needRedirect: (!isSubdomain && !!city.subdomain) || undefined,
    });
  }
  nextTick(() => {
    selectCityModal.value = false;
  });
};
const approveCity = () => {
  if (localRegion.value.id === region.value.id) {
    $ymAnyEvent('reachGoal', 'click_city');
    const { domainWithPort, isSubdomain, domain } = hostData(
      window.location.hostname,
      window.location.port
    );
    const cookieRegion = useCookie('region', {
      path: '/',
      domain,
      maxAge,
    });

    cookieRegion.value = JSON.stringify({
      id: region.value.id,
      name: region.value.name,
      subdomain: region.value.subdomain,
    });
    // needRedirect если пользователь на корневом домене, а на подвержденом регионе свой поддомен
    globalStore.setRegion({
      needQuestion: false,
      needRedirect: (!isSubdomain && !!region.value.subdomain) || undefined,
    });
    if (
      nuxtApp.vueApp.$nuxt?.$ymInit &&
      typeof nuxtApp.vueApp.$nuxt?.$ymInit === 'function'
    )
      nuxtApp.vueApp.$nuxt?.$ymInit();
    if (!isSubdomain && !!region.value.subdomain) {
      const newLocation =
        '//' +
        (region.value?.subdomain ? region.value?.subdomain + '.' : '') +
        domainWithPort +
        window.location.pathname +
        window.location.search;
      navigateTo(newLocation, {
        external: true,
        redirectCode: 301,
      });
    }
  } else {
    setActiveCity(localRegion.value);
  }
};
const cancelCity = () => {
  selectCityModal.value = true;
};
const setSearchFocus = () => {
  if (searchelement.value) {
    const inputElement: HTMLElement = searchelement.value.querySelectorAll(
      'input#input-search-field'
    )[0] as HTMLElement;
    if (inputElement) {
      inputElement?.click();
      inputElement?.focus();
    }
    showMobileSearch.value = true;
  }
};
const sendYa = () => {
  if (mediaStore.isDesktop) {
    $ymAnyEvent('reachGoal', 'click_katalog');
  }
};
const sendYaClick = (href: string) => {
  switch (href) {
    case '/promokody/':
      $ymAnyEvent('reachGoal', 'click_promokod');
      break;
    case '/promo/sale/':
      $ymAnyEvent('reachGoal', 'click_skidky');
      break;
    case 'https://price.ru/blog/':
      $ymAnyEvent('reachGoal', 'click_blog');
      break;
    case '/brands/':
      $ymAnyEvent('reachGoal', 'click_brands');
      break;
    case '/magaziny/':
      $ymAnyEvent('reachGoal', 'click_magazine');
      break;
    case '/sistemnye-bloki/':
      $ymAnyEvent('reachGoal', 'click_comp');
      break;
    case '/mobilnye-telefony/smartfony/':
      $ymAnyEvent('reachGoal', 'click_smart');
      break;
    case '/bytovye-holodilniki-morozilniki/':
      $ymAnyEvent('reachGoal', 'click_holod');
      break;
    case '/televizory/':
      $ymAnyEvent('reachGoal', 'click_tv');
      break;
    case 'https://biz.price.ru/welcome/':
      $ymAnyEvent('reachGoal', 'click_b2b');
      break;
  }
};
const onResize = () => {
  if (navDiv.value && headerDiv.value) {
    navDiv.value.style.left =
      -1 * headerDiv.value.getBoundingClientRect().left + 'px';
  }
};

const setLocalRegion = () => {
  const cookieRegion = useCookie<RegionInApp>('region');
  if (cookieRegion.value && cookieRegion.value?.id) {
    localRegion.value = {
      id: cookieRegion.value?.id,
      name: cookieRegion.value?.name,
      subdomain: cookieRegion.value?.subdomain,
      parents: cookieRegion.value?.parents || [],
    };
  } else if (globalStore.localRegion) {
    localRegion.value = globalStore.localRegion;
  } else {
    localRegion.value = region.value;
  }
};
setLocalRegion();
onMounted(() => {
  html.value = document.querySelector('html');
  if (globalStore.region.needQuestion && !import.meta.env.SSR) {
    $ymAnyEvent('reachGoal', 'city');
  }
  window.addEventListener('resize', onResize);
  onResize();
});
onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize);
});
const clickHeaderMenu = () => {
  openHeaderMenu.value = !openHeaderMenu.value;
  if (openHeaderMenu.value) {
    html?.value?.classList.add('has-modal');
  } else {
    html?.value?.classList.remove('has-modal');
  }
};

const showExclusive = () => {
  modalsStore.setData({
    name: 'exclusive',
    data: 'exclusive',
  });
  $ymAnyEvent('reachGoal', 'click_LD');
};
watch(
  () => isMenuOpen.value,
  (v) => {
    isLocked.value = v;
  }
);
if (!import.meta.env.SSR) {
  router.afterEach(() => {
    if (html?.value?.classList) {
      html.value.classList.remove('has-modal');
    }
    showMobileSearch.value = false;
  });
}
</script>

<style lang="scss" scoped>
.header-wrapper {
  height: 52px;
  position: relative;
  --text-color: #{$achromatic-black};
  --text-color-rgb: 36, 36, 36;
  --bg-color: var(--header-bg-color, #{$achromatic-card-bg});
  background-color: $white;
  color: $achromatic-black;

  &__banner {
    height: 100px;
  }

  @include md-block {
    height: 110px;
  }
  @include xl-block {
    height: 124px;
  }

  .shadow {
    position: absolute;
    background: transparent;
    pointer-events: none;
    width: 100%;
    height: 52px;
    top: 0;
    left: 0;
    z-index: 39;
    box-shadow: 0 1px 8px 0 rgba(85, 91, 143, 0.08);
    @include md-block {
      display: none;
    }
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    @include md-block {
      align-items: flex-end;
      flex-wrap: wrap;
      padding-top: 8px;
      row-gap: 8px;
      height: unset;
    }
    @include xl-block {
      padding-top: 12px;
      row-gap: 12px;
    }

    .nav-container {
      width: 100vw;
      position: fixed;
      top: var(--promobannerheight, 0px);
      left: 0;
      z-index: 80;
      @include xl-block {
        top: 0;
        position: absolute;
        z-index: 95;
      }

      .nav {
        height: calc(
          (var(--fullvh, 100%)) - 50px - (var(--promobannerheight, 0px))
        );
        overflow: hidden;
        background: white;
        display: flex;
        box-shadow: inset 0px -2px 12px 0px rgb(85 91 143 / 8%);
        @include md-block {
          box-shadow: none;
        }
        @include xl-block {
          height: calc(100vh - 64px);
        }
        @include xxl-block {
          height: calc(100vh - 72px);
        }
      }

      @include xl-block {
        top: 64px;
      }
      @include xxl-block {
        top: 72px;
      }
    }

    .header-menu-open {
      height: 52px;
      width: 40px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 0;
      margin-right: 4px;
      z-index: 32;
      user-select: none;
      margin-left: -4px;

      &.go-up {
        z-index: 40;
      }

      @include md-block {
        display: none;
      }
    }

    .logo {
      display: flex;
      align-items: center;

      &:active,
      &:focus {
        outline: none;
      }

      img {
        width: 95px;
        height: 32px;
      }

      @include md-block {
        .img {
          width: 120px;
          height: 40px;
        }
      }
      @include xl-block {
        .img {
          width: 136px;
          height: 46px;
        }
      }
    }

    .header-search-button-mob {
      display: inline-flex;
      border: none;
      height: 100%;
      align-items: center;
      background: inherit;
      cursor: pointer;
      padding-left: 8px;
      padding-right: 12px;
      margin-right: -12px;

      .header-search-button-mob-icon-wrap {
        padding: 8px;
        background: $main-cta;
        border-radius: 6px;
      }

      @include md-block {
        display: none;
      }
    }
  }

  .catalog-button {
    position: relative;
    cursor: pointer;
    display: none;
    background: $main-cta;
    padding: 13px 2px 13px 11px;
    font-size: 0;
    color: white;
    text-align: center;
    border-radius: 6px;
    grid-template-columns: 24px max-content;
    align-items: center;
    grid-gap: 3px;
    @include fz(16, 20, 500);
    user-select: none;
    justify-content: center;

    .label {
      display: none;
    }

    @include md-block {
      display: grid;
      margin-left: 40px;
    }
    @include xl-block {
      padding: 10px 16px 10px 12px;
      border-radius: 8px;
      margin: 2px 0 2px 43px;
      @include fz(16, 24, 450);
      .label {
        display: inline;
      }
    }
    @include xxl-block {
      margin-left: 83px;
    }

    &--blue {
      background: white;
      color: $main-cta;
    }
  }

  .bm-in-header {
    display: none;
    align-items: center;
    justify-content: center;
    position: static;
    bottom: unset;
    left: unset;
    right: unset;
    z-index: 0;
    padding: 0;
    transform: none;
    box-shadow: none;
    max-width: 196px;

    :deep(.list) {
      gap: 12px;

      .home,
      .catalog {
        display: none;
      }

      .item {
        flex-grow: 1;
        padding: 0;
        gap: 4px;
        max-height: 48px;

        .image-container {
          .image {
            width: 24px;
            height: 24px;
          }

          .badge {
            top: -1px;
            @include fz(10, 10, 600);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 2px 2px;
            min-width: 16px;
          }
        }

        @include xl-block {
          .title {
            @include fz(14, 20, 450);
          }
        }
      }

      .nuxt-link-exact-active,
      .router-link-exact-active {
        .image-container {
          background: none;

          .image {
            //background-color: #242424;
          }
        }

        .title {
          color: #86888f;
        }
      }
    }

    @include xl-block {
      display: flex;
      margin-left: 39px;
    }
    @include xxl-block {
      display: flex;
      margin-left: 79px;
    }
  }

  .line-second-line {
    display: flex;
    flex-wrap: nowrap;
    flex-grow: 1;
    max-width: 100%;
    justify-content: flex-end;
    @include md-block {
      padding: 8px 0 12px;
      justify-content: unset;
    }

    .city-wrapper {
      position: relative;
      max-width: 240px;
      flex-grow: 1;
      flex-shrink: 0;
      flex-basis: auto;
      margin: 0 12px;
      text-align: right;
      @include md-block {
        margin: 0;
        width: auto;
        flex-grow: 0;
        max-width: unset;
        margin-right: 24px;
        border-radius: 8px;
        background: $achromatic-card-bg;
        padding: 6px 12px 6px 8px;
      }

      .city {
        position: relative;
        cursor: pointer;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        min-width: auto;
        @include xl-block {
          min-width: unset;
        }

        .question-wrapper {
          position: relative;
          display: flex;
          gap: 2px;

          .geo-icon {
            margin-top: 1px;
            @include lg-block {
              margin-top: 0;
            }
          }
        }

        .name {
          cursor: pointer;
          position: relative;
          color: $achromatic-black;
          transition: color 0.3s ease;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: flex;
          align-items: center;

          .city-name {
            color: $achromatic-black;
            max-width: 88px;
            overflow: hidden;
            display: inline-block;
            text-overflow: ellipsis;
            @include md-block {
              max-width: unset;
              overflow: unset;
            }
          }
        }
      }
    }

    .horizontal-scroll {
      display: none;
      @include md-block {
        display: flex;
      }

      .site-menu {
        display: none;
        gap: 24px;
        flex-grow: 1;
        align-items: center;
        align-self: center;

        li {
          white-space: nowrap;
          @include fz(14, 20, 400);
          display: none;

          a {
            display: flex;
            align-items: center;
            gap: 4px;
          }

          &.delimeter {
            width: 1px;
            height: 20px;
            background: #d3d3d3;
          }

          &.allways {
            display: list-item;
          }

          &.desktop {
            display: none;
            @include xl-block {
              display: list-item;
            }
          }

          &.superdesktop {
            display: none;
            @include xxl-block {
              display: list-item;
            }
          }
        }

        @include md-block {
          display: flex;
        }
        @include xl-block {
          justify-content: space-between;
        }
      }
    }
  }

  .city-select-modal {
    height: 100vh;
    @include xl-block {
      height: auto;
    }
  }

  &.header-modal {
    transition: none;
    background: $white;
    z-index: 101;
    @include xl-block {
      z-index: initial;
    }

    .header {
      &.main-container {
        z-index: 76;
        margin: 0 auto;
        padding: 8px 40px;
        @include xl-block {
          padding: 12px 40px;
        }
      }

      &.l-container {
        overflow: unset;
      }
    }

    .logo {
      display: none;
      @include xl-block {
        display: flex;
      }
    }

    .catalog {
      .catalog-text {
        &::before,
        &::after {
          content: '';
          position: absolute;
          top: calc(50% - 2px);
          left: 0;
          width: 18px;
          height: 2px;
          background-color: $white;
          transition: transform 0.2s;
          border-radius: 1px;
        }

        &::before {
          transform: rotate(45deg);
        }

        &::after {
          transform: rotate(-45deg);
        }
      }
    }
  }

  &.header-not-modal {
    background-color: $white;
    //transition: background-color 1s ease, box-shadow 0s;
    box-shadow: 0 1px 8px 0 rgba(85, 91, 143, 0.08);

    .catalog {
      .catalog-text:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 18px;
        height: 2px;
        background-color: $white;
        box-shadow: 0 6px 0 0 $white, 0 12px 0 0 $white;
        transition: background-color 0.2s;
        border-radius: 1px;
      }

      .reg-btn--invert .catalog-text:before {
        background-color: $achromatic-card-bg;
        box-shadow: 0 6px 0 0 $achromatic-card-bg,
          0 12px 0 0 $achromatic-card-bg;
        border-radius: 1px;
      }
    }
  }

  .search {
    display: flex;
    align-items: center;
    padding: 0 32px 0 12px;
    flex: 0 0 auto;
    width: calc(100% - 200px);
    position: absolute;
    top: -100px;

    &.show-mobile-search {
      position: static;
      top: unset;
    }

    .catalog-visible:not(.focus) {
      padding-right: 32px;
    }

    @include md-block {
      position: static;
      top: unset;
      padding: 0 0 0 12px;
      align-items: flex-start;
      .catalog-visible:not(.focus) {
        padding-right: 0;
      }
    }
    @include xl-block {
      width: calc(100% - 532px);
      margin: 2px 0;
      padding: 0 0 0 16px;
    }
    @include xxl-block {
      width: calc(100% - 612px);
      padding: 0 0 0 16px;
    }
  }

  .exclusive {
    height: 32px;
    width: 160px;
    cursor: pointer;
    border-radius: 8px;
    background-image: url('/static/images/exclusive.png');
    background-position: center center;
    background-size: 100%;
    background-repeat: no-repeat;

    &__gif {
      background-image: url('/static/images/exclusive.gif');
    }
  }

  .exclusive-mobile {
    margin: 0 12px 12px;
    width: calc(100% - 24px);
    height: 36px;
    background-color: $purple;
    display: flex;
    justify-content: center;
    border-radius: 8px;

    &__banner {
      width: 288px;
      height: 36px;
      background-image: url('/static/images/exclusive-mobile.png');
      background-position: center center;
      background-size: 100%;
      background-repeat: no-repeat;
      border-radius: 6px;
    }

    &__gif {
      background-image: url('/static/images/exclusive-mobile.gif');
    }

    @include md-block {
      display: none;
    }
  }
}

.question {
  background-color: #242424;
  color: white;
  position: absolute;
  z-index: 76;
  right: -30px;
  left: auto;
  bottom: auto;
  top: 30px;
  display: flex;
  width: 260px;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 6px;
  box-shadow: 0 4px 20px 0 rgba(36, 36, 36, 0.2);

  @include md-block {
    right: auto;
    left: calc(100% + 24px);
    bottom: auto;
    top: -6px;
  }
  @include xl-block {
    z-index: 80;
    width: 296px;
  }

  .text {
    @include fz(12, 16, 400);
    @include xl-block {
      @include fz(14, 20, 400);
    }

    b {
      font-weight: 600;
    }
  }

  .buttons {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 8px;

    * {
      flex: 1 1;
    }
  }

  &:after {
    content: '';
    mask: url('/static/images/social-share-popup-hvostik.svg') center / contain
      no-repeat;
    background-color: #242424;
    width: 13px;
    height: 8px;
    position: absolute;
    top: -8px;
    right: 50px;
    @include md-block {
      right: auto;
      top: 11px;
      left: -10px;
      transform: rotate(-90deg);
    }
  }
}
</style>
